import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrelViewerContext } from 'features/kestrelViewer'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React from 'react'
import styled from 'styled-components'

const ThermalButtonContainer = styled.div`
  position: relative;
`

const ThermalIcon = styled.div`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
    fill: currentColor;
  }
`

const ThermalSVG = () => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <defs>
      <linearGradient id='thermalGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
        <stop offset='0%' stopColor='currentColor' stopOpacity='0.1' />
        <stop offset='50%' stopColor='currentColor' stopOpacity='0.5' />
        <stop offset='100%' stopColor='currentColor' stopOpacity='0.9' />
      </linearGradient>
    </defs>
    <rect
      x='2'
      y='3'
      width='20'
      height='18'
      rx='2'
      fill='url(#thermalGradient)'
      stroke='currentColor'
      strokeWidth='1'
    />
  </svg>
)

export const ThermalGradientButton: React.FC = () => {
  const { thermalGradientVisible, setThermalGradientVisible } =
    useKestrelViewerContext()

  const handleToggle = (
    selected: boolean,
    setSelected: (value: boolean) => void
  ) => {
    const newState = !selected
    setSelected(newState)
    setThermalGradientVisible(newState)
  }

  return (
    <ThermalButtonContainer>
      <TooltipWrapper side='top' offset={5} label='Thermal Gradient'>
        <ViewToggle selected={thermalGradientVisible} onClick={handleToggle}>
          <ThermalIcon>
            <ThermalSVG />
          </ThermalIcon>
        </ViewToggle>
      </TooltipWrapper>
    </ThermalButtonContainer>
  )
}
